import React, { useEffect, useState } from "react";
import styles from "./privacyPolicy.module.css";
import { Typography } from "antd";
import { useDispatch } from "react-redux";
import InfoPagesMiddleware from "../../store/Middlewares/InfoPagesMiddleware";
import { t } from "i18next";
// import { useTranslation } from "react-i18next";

function PrivacyPolicy() {
  const dispatch = useDispatch();
  const [infoData, setInfoData] = useState("");
  console.log('infodataaaa', infoData);
  // const { t, i18n } = useTranslation();
  useEffect(() => {
    getInfoData();
    // getLanguage();
  }, []);
  // const getLanguage = async () => {    try {      const language = await AsyncStorage.getItem('@selectedLanguage');      i18n.changeLanguage(language)    } catch (e) {      console.log(e)    }  };
  const getInfoData = () => {
    dispatch(InfoPagesMiddleware.getInfo())
      .then((data) => {
        setInfoData(data?.data[0]?.privacy);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const { Text } = Typography;
  return (
    <div className={styles.mainCont}>
      <Text className={styles.subText} >{t("Privacy Policy")}</Text>
      <span className={styles.contentStyling} dangerouslySetInnerHTML={{ __html: infoData }} />
    </div>
  );
}

export default PrivacyPolicy;
